import { Pipe, PipeTransform } from '@angular/core';
import { LocaleService } from '../services/locale.service';

@Pipe({
  name: 'myCurrency',
})
export class MyCurrencyPipe implements PipeTransform {
  constructor(private localeService: LocaleService) {}

  transform(value: number): string {
    if (value) {
      return new Intl.NumberFormat(this.localeService.locale, {
        style: 'currency',
        currency: this.localeService.currency,
        minimumFractionDigits: 0,
      }).format(value);
    } else {
      return '';
    }
  }
}
